import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=f6b52a9c&scoped=true&lang=html&"
import script from "./Groups.vue?vue&type=script&lang=js&"
export * from "./Groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b52a9c",
  null
  
)

export default component.exports